module.exports = __webpack_public_path__ + "static/media/lc_oct.8e42cbfd.png";